function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  transform: "translate(0 0.625)",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3911_117579)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.7986 32.9167L46.1111 38.4028C46.1574 39.2014 45.6829 39.9421 44.6875 40.625C43.6921 41.3079 42.3322 41.849 40.6076 42.2483C38.8831 42.6476 37.0139 42.8472 35 42.8472C32.9861 42.8472 31.1169 42.6476 29.3924 42.2483C27.6678 41.849 26.3079 41.3079 25.3125 40.625C24.3171 39.9421 23.8426 39.2014 23.8889 38.4028L24.2014 32.9167L34.1667 36.059C34.4213 36.14 34.6991 36.1806 35 36.1806C35.3009 36.1806 35.5787 36.14 35.8333 36.059L45.7986 32.9167ZM55 27.2917C55 27.5579 54.8727 27.7373 54.6181 27.8299L35.1736 33.941C35.1273 33.9525 35.0694 33.9583 35 33.9583C34.9306 33.9583 34.8727 33.9525 34.8264 33.941L23.5069 30.3646C23.0093 30.7581 22.5984 31.4034 22.2743 32.3003C21.9502 33.1973 21.7535 34.2303 21.684 35.3993C22.4132 35.816 22.7778 36.4468 22.7778 37.2917C22.7778 38.0903 22.4421 38.7095 21.7708 39.1493L22.7778 46.6667C22.8009 46.8287 22.7546 46.9734 22.6389 47.1007C22.5347 47.228 22.3958 47.2917 22.2222 47.2917H18.8889C18.7153 47.2917 18.5764 47.228 18.4722 47.1007C18.3565 46.9734 18.3102 46.8287 18.3333 46.6667L19.3403 39.1493C18.669 38.7095 18.3333 38.0903 18.3333 37.2917C18.3333 36.4468 18.7095 35.8044 19.4618 35.3646C19.5891 32.9687 20.1563 31.059 21.1632 29.6354L15.3819 27.8299C15.1273 27.7373 15 27.5579 15 27.2917C15 27.0255 15.1273 26.8461 15.3819 26.7535L34.8264 20.6424C34.8727 20.6308 34.9306 20.625 35 20.625C35.0694 20.625 35.1273 20.6308 35.1736 20.6424L54.6181 26.7535C54.8727 26.8461 55 27.0255 55 27.2917Z",
  fill: "#C1C1C1"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3911_117579"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 26.6667,
  fill: "white",
  transform: "translate(15 20.625)"
})));

function SvgIcHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHat);
export default __webpack_public_path__ + "static/media/ic_hat.a1f98a33.svg";
export { ForwardRef as ReactComponent };